export default {
  path: 'settings',
  name: 'settings',
  component: () => import('@views/top-bar/settings/Index'),
  meta: {
    title: 'data.menu.settings.meta.title',
  }
};
